import React from "react";

import "./AboutSolutions.css";

const AboutSolutions = () => {
  return (
    <section className="aboutSolutionsContainer">
      <h2 className="aboutSolutionsTitle">SOLUCIONES INTEGRALES</h2>
      <div className="aboutSolutionsBody">
        <p>
            En Thorne Global Real Estate Dubai, no solo ofrecemos los servicios tradicionales de una agencia inmobiliaria, sino que también brindamos una gama de servicios personalizados que garantizan una experiencia integral y exclusiva para nuestros clientes más exigentes.
        </p>
        <p>
            Gestión Integral de Inversiones Inmobiliarias: Servicio que optimiza retornos mediante análisis de mercado, asesoramiento personalizado y gestión diversificada de portafolios.
        </p>
        <p>
            Consultoría Estratégica Jurídica Inmobiliaria: Asesoría en contratos, Derecho Internacional Privado y gestión legal para transacciones inmobiliarias globales, en colaboración con expertos locales e internacionales.
        </p>
        <p>
            Networking Internacional: Conexión estratégica con inversores y desarrolladores clave, creando oportunidades de negocio en mercados globales.
        </p>
      </div>
    </section>
  );
};

export default AboutSolutions;